module.exports = __webpack_public_path__ + "Flag-792.d6b31dca26b3d58c1126e307294dc1d7.svg";